<template>
  <section>
    <batches-filter class="mb-5" />

    <batches-list />
  </section>
</template>

<script>
import BatchesFilter from '@/components/PrintLabels/Batches/BatchesFilter'
import BatchesList from '@/components/PrintLabels/Batches/BatchesList'

export default {
  name: 'Batches',
  components: {
    BatchesFilter,
    BatchesList
  }
}
</script>
